import { render, staticRenderFns } from "./workspace_dropdown_item.vue?vue&type=template&id=41e1ac2b&vue3"
import script from "./workspace_dropdown_item.vue?vue&type=script&lang=js&vue3"
export * from "./workspace_dropdown_item.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports